import {type ThemeIconKey} from 'platform/foundation';

import {ActivitySidebarAction} from '@dms/features/activity-panel';
import i18n from '@dms/i18n';

import {AuctionHistory} from './AuctionHistory';

interface BuildAuctionHistorySidebarActionParams {
  vehicleId: string;
}

const AUCTION_HISTORY_ICON: ThemeIconKey = 'action/history';

export function buildAuctionHistorySidebarAction(params: BuildAuctionHistorySidebarActionParams) {
  return {
    id: 'auction-history',
    label: i18n.t('entity.auction.labels.auction'),
    icon: AUCTION_HISTORY_ICON,
    component: <AuctionHistory vehicleId={params.vehicleId} />,
  } satisfies ActivitySidebarAction;
}
